import { get } from "../../pwa/ajax";
import * as Cookie from "../common/cookie";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import * as SessionLogin from "../common/session";
import * as ClearLoQueSigo from './ClearLoQueSigo';

const urlBucket = window.config.Statics.BucketUrl;
const urlNavAnonimo = window.config.Statics.ApiNavAnonimaHome;
const urlNavAnonimoExt = window.config.Statics.ApiNavAnonimaExt;

const showErr = console.error.bind(console, "perso ");
const showLog = console.log.bind(console, "perso ");


//TODO: HACER REFACTOR DE ESTE JS, QUEDANDO EN EL MISMO TODO LO DE APIPERSO Y LO DE LOCALSTORAGE, SACAR LO DE PERSO DE LOS OTROS ARCHIVOS, LOQUESIGO, HOME, NOTA, ETC....
//TODO: PODEMOS HACER QUE DESDE SESSION.JS SE LLAME A PERSONALIZACION Y EN EL INICIO YA TENER TODO CARGADO

export const seguirDejarSeguir = (element) => {

    for (let btn of Array.from(element)) {
        btn.addEventListener('click',
            function(event) {

                if (!SessionLogin.init()) {                    
                    let dataPreferible = "{dataPreferibleId}|{dataPreferibleTipoId}"
                        .replace("{dataPreferibleId}",event.currentTarget.getAttribute('data-preferibleId'))
                        .replace("{dataPreferibleTipoId}",event.currentTarget.getAttribute('data-preferibleTipoId'));

                    localStorage.setItem("apiPerso.Pendientes.Preferencias",dataPreferible);

                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }

                const apiPerso = SessionLogin.initPerso();

                if (event.currentTarget.classList.contains("activo")) {
                    event.currentTarget.classList.remove("activo");
                    event.currentTarget.innerText = "SEGUIR";
                    apiPerso.preferencias.dejarDeSeguirPreferible(
                        event.currentTarget.getAttribute('data-preferibleId'),
                        event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute()
                        .then(resp => { 
                            dejarSeguirOrSeguir();
                        })
                        .catch(console.log.bind(console, 'error'));                    

                } else {
                    event.currentTarget.classList.add("activo");
                    event.currentTarget.innerText = "SIGUIENDO";
                    apiPerso.preferencias.seguirPreferible(event.currentTarget.getAttribute('data-preferibleId'),
                        event.currentTarget.getAttribute('data-preferibleTipoId'));
                    apiPerso.execute()
                        .then(resp => {  
                            dejarSeguirOrSeguir();
                        })
                        .catch(console.log.bind(console, 'error'));
                }
            });
    }
}

const dejarSeguirOrSeguir = () => {

    const apiPerso = SessionLogin.initPerso();

    if (!SessionLogin.init()) {
        location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
        return;
    }     
    
    apiPerso.execute()
        .then(resp => {  
            ClearLoQueSigo.clearLS();          
        })                    
        .catch(console.log.bind(console, 'error'));    
}



export const preferenciasPendientes = () => {

    const apiPerso = SessionLogin.initPerso();

    let preferenciasPendientes = localStorage.getItem("apiPerso.Pendientes.Preferencias");

    if(preferenciasPendientes != null)
    {
        let datosPreferencias = preferenciasPendientes.split("|");

        apiPerso.preferencias.seguirPreferible(
            parseInt(datosPreferencias[0]),
                        parseInt(datosPreferencias[1]));


        apiPerso
            .execute()
            .then(resp => {                
                localStorage.removeItem("apiPerso.Pendientes.Preferencias");
            })
            .catch(showErr.bind(console, "execute"));
    }
}

export const dejarSeguirLoQueSigo = (element) => {

    const apiPerso = SessionLogin.initPerso();

    for (let btn of Array.from(element)) {
        btn.addEventListener('click',
            function(event) {

                if (!SessionLogin.init()) {
                    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
                    return;
                }                

                apiPerso.preferencias.dejarDeSeguirPreferible(
                    event.currentTarget.getAttribute('data-preferibleId'),
                    event.currentTarget.getAttribute('data-preferibleTipoId'));
                apiPerso.execute()
                    .then(resp => {
                        ClearLoQueSigo.clearLS();
                    })                    
                    .catch(console.log.bind(console, 'error'));
                 
                event.currentTarget.parentNode.remove();
            });
    }
}

//////////////////
//  LO QUE SIGO //
//////////////////
export const initPreferencias = () => {
    const ctx = null;
    const obtenerNotaId = document.querySelector('div[data-notaId]').getAttribute("data-notaId");
    const obtenerTemas = document.querySelector('div[data-preferibles]').getAttribute('data-preferibles').split(',');
    
    let obtenerSugerencias = localStorage.getItem("obtenerSugerencias");
    let obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
    let obtenerPreferibles = localStorage.getItem("obtenerPreferibles");

    if (SessionLogin.init()) {

        preferenciasPendientes();

        const apiPerso = SessionLogin.initPerso();

        apiPerso.sugerencias.lecturaNota(obtenerNotaId)
            .then(showLog.bind(console, 'lecturaNota'))
            .catch(showErr.bind(console, 'lecturaNota'));

        apiPerso.sugerencias.registrarTemas(obtenerTemas, ctx)
            .then(showLog.bind(console, 'registrarTemas'))
            .catch(showErr.bind(console, 'registrarTemas'));



        if (obtenerSugerencias === null) {
            apiPerso.sugerencias.obtener("", 25)
                .then(resp => {
                    localStorage.setItem("obtenerSugerencias", JSON.stringify(resp));
                    obtenerSugerencias = localStorage.getItem("obtenerSugerencias");;
                })
                .catch(showErr.bind(console, 'obtener sugerencias'));
        }

        if (obtenerHashSuscripciones === null) {
            apiPerso.preferencias.obtenerHashSuscripciones()
                .then(resp => {
                    localStorage.setItem("obtenerHashSuscripciones", resp);
                    obtenerHashSuscripciones = localStorage.getItem("obtenerHashSuscripciones");
                })
                .catch(showErr.bind(console, "Obtener hash suscripciones"));
        }

        if (obtenerPreferibles === null) {
            apiPerso.preferencias.obtenerPreferibles()
                .then(resp => {
                    localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));
                    obtenerPreferibles = localStorage.getItem("obtenerPreferibles");
                    
                })
                .catch(showErr.bind(console, "Obtener preferibles"));
        }

        apiPerso
            .execute()
            .then(resp => {
                preferencias(obtenerHashSuscripciones, apiPerso);
                ejecutarSugerenciasPreferencias(JSON.parse(obtenerSugerencias));
                preferenciasCambioBotonSiguiendo();
            })
            .catch(showErr.bind(console, "execute"));   
    } else {
        //NO LOGUEADO 
        getDataNoLogueado();  
       
        if(isSessionDateExpired())
        {
            reLoadSugerenciasAnonimas();
        }
    }
}

const isSessionDateExpired = () => {
    const createdDate = localStorage.getItem("sugerenciasNoLoginCreated");
    let cacheMiliseconds = 300000; ///TODO:pasar a configuracion
    let dif = 0;

    if (createdDate === null) {
        return true;
    } else {
        dif = Date.now() - createdDate;
        if (dif < cacheMiliseconds) {
            return false;
        } else {
            return true;
        }
    }
}

const reLoadSugerenciasAnonimas = () => {

    localStorage.removeItem("sugerenciasNoLogin");
    getDataNoLogueado();

}

export const preferenciasCambioBotonSiguiendo = () => {
    //TODO: Refactor ver donde se puede hacer esta llamada una sola vez para reutilizacion inicial de todas las pag
    let LSPreferible = localStorage.getItem("obtenerPreferibles");    
    
    if (!SessionLogin.init()) { return; }

    if (LSPreferible === null) {

        const apiPerso = SessionLogin.initPerso();

        apiPerso.preferencias.obtenerPreferibles()
            .then(resp => {
                localStorage.setItem("obtenerPreferibles", JSON.stringify(resp));                                    
            })
            .catch(showErr.bind(console, "Obtener preferibles"));

        apiPerso
            .execute()
            .then(resp => {
                cambioBotonSiguiendo();
            })
            .catch(showErr.bind(console, "execute"));   

    }
    else{
        cambioBotonSiguiendo();
    }
}

const cambioBotonSiguiendo = () => {
    let LSPreferible = localStorage.getItem("obtenerPreferibles");
    if (LSPreferible == null) return;

    let dataPreferibles = JSON.parse(LSPreferible);
    let idsPreferibles = [];
    document.querySelectorAll('button.seguir').forEach(function(elem) {
        idsPreferibles.push(elem.getAttribute('data-preferibleid'));
    });

    for (var preferible of dataPreferibles) {
        if (idsPreferibles.indexOf(preferible.id.toString()) != -1) {
            let nodo = document.querySelectorAll('button.seguir[data-preferibleid="' + preferible.id + '"]');            
            
            nodo.forEach(function(element, index) {
                element.textContent = 'SIGUIENDO';
                element.classList.add('activo');
            });
            
        }
    }
}

const preferencias = (hash, apiPerso) => {
    if (hash !== null) {
        //Obtener las Preferencias y competando con sugerencias llegado el caso.
        obtenerDatosPreferencias(false, renderPreferencias, apiPerso);
    } else { //SIN PREFERENCIAS
        //Obtener sugerencias pero NO completar con preferencias llegado el caso.
        obtenerDatosSugerencias(false, renderSugerenciasTemas, apiPerso);
    }
}

//Prefgerencias
const obtenerDatosPreferencias = (rellenar, callback, apiPerso) => {
    //Solo temas, NO notas
    let obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
    let obtenerNovedades = localStorage.getItem("obtenerNovedades");
    let recomendarTemas = localStorage.getItem("recomendarTemas");

    if (obtenerPorPrioridad === null) {
        apiPerso.comunes.obtenerPorPrioridad(rellenar, 8, "Preferencia")
            .then(resp => {
                localStorage.setItem("obtenerPorPrioridad", JSON.stringify(resp));
                obtenerPorPrioridad = localStorage.getItem("obtenerPorPrioridad");
            });    
    }

    if (obtenerNovedades === null) {
        apiPerso.preferencias.obtenerNovedades()
            .then(resp => {
                localStorage.setItem("obtenerNovedades", resp[0].cantidad);
                obtenerNovedades = localStorage.getItem("obtenerNovedades");
            });    
    }

    if (recomendarTemas === null) {
        //Para temas y autores mas sugeridos
        apiPerso.sugerencias.recomendarTemas(5)
            .then(resp => {
                localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                recomendarTemas = localStorage.getItem("recomendarTemas");
            });    
    }

    apiPerso.execute()
        .then(resp => {
            callback(JSON.parse(obtenerPorPrioridad), obtenerNovedades, JSON.parse(recomendarTemas));
        })
        .catch(showErr.bind(console, "execute"));
}
//Sugerencias
const obtenerDatosSugerencias = (rellenar, callback, apiPerso) => {
    //Solo temas, NO notas
    let recomendarTemas = localStorage.getItem("recomendarTemas");
    
    if (recomendarTemas === null) {
        //Para temas y autores mas sugeridos
        apiPerso.sugerencias.recomendarTemas(5)
            .then(resp => {
                localStorage.setItem("recomendarTemas", JSON.stringify(resp));
                recomendarTemas = localStorage.getItem("recomendarTemas");
            });
    }

    apiPerso.execute()
        .then(resp => {
            callback(JSON.parse(recomendarTemas));
        })
        .catch(showErr.bind(console, "execute"));
}

const renderPreferencias = (preferencias, cantNotasNoLeidas, temasRecomendados) => {
    let html = "";
    let css;

    //CON notas a leer. (si hay pocas, completa con Sugerencias)
    if (cantNotasNoLeidas > 0) {
        css = "nuevas";
        html = `<div class="techo floatFix">
                    <span class="subtitulo">Tus temas y autores </span>
                    <h4><span>${cantNotasNoLeidas}</span> nuevas notas </h4>
                    <a href="/lo-que-sigo"> Configurar </a>
                </div>`;
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += `<div class="ver-mas">
                    <a href="/lo-que-sigo">VER MÁS NOTAS</a>
                 </div>`;
    } else if (preferencias.length === 0) {
        //SIN Preferencias NI Sugerencias.
        css = "sin-seguir";
        html = `<div class="techo floatFix">
                    <h4>SEGUÍ LOS TEMAS Y AUTORES QUE <b>MÁS TE INTERESAN</b></h4>
                </div>
                <p> Buscá el botón: <span class="seguir">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>
                <section class="mas-seguidos">
                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>`;

        for (let tema of temasRecomendados) {
            const id = tema[0],
                idTipo = tema[3];

            html += `<div class="tema floatFix"><p>${tema[5]}</p>
                 <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="${idTipo}">SEGUIR</button></div>`;
        }
        html += `</section>`;
    } else {
        //SIN nota a leer (Llenar con sugerencias)
        css = "recomendadas";
        html += `<div class="techo floatFix">
                    <span class="subtitulo">Tus temas y autores </span>
                    <h4>RECOMENDADOS</h4>
                    <a href="/lo-que-sigo"> Configurar </a>
                </div>`;
        //Articles
        html += loopArticles(preferencias, 8);
        //Botones
        html += `<div class="ver-mas">
                    <a href="/lo-que-sigo">VER MÁS NOTAS</a>
                </div>`;
    }

    const asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}

const renderSugerenciasTemas = (temasRecomendados) => {
    const css = "sin-seguir";
    let html = `<div class="techo floatFix">
                    <h4>SEGUÍ LOS TEMAS Y AUTORES QUE <b>MÁS TE INTERESAN</b></h4>
                </div>
                <p> Buscá el botón: <span class="seguir">SEGUIR</span> para guardarlos en tus favoritos y enterate, al instante, cada vez que haya nuevas notas.</p>
                <section class="mas-seguidos">
                <h5> MIENTRAS PODES SEGUIR ESTOS TEMAS:</h5>`;

    for (let tema of temasRecomendados) {
        const id = tema[0],
              idTipo = tema[3];

        html += `<p>${tema[5]}</p>
                 <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="${idTipo}">SEGUIR</button>`;
    }

    html += `</section>`;
    
    const asideBloque2 = document.querySelector("#bloque-2");
    asideBloque2.classList.add(css);
    asideBloque2.innerHTML = html;
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}

const getDataNoLogueado = () => {

    let resp;   

    let sugerenciasNoLoginLS = localStorage.getItem("sugerenciasNoLogin");

    if(sugerenciasNoLoginLS != null){
        renderNoLogueado(JSON.parse(sugerenciasNoLoginLS));
        sugerenciasNoLogin(JSON.parse(sugerenciasNoLoginLS));
    }else{
        if(randomFn() > 5)
        {
            get(urlNavAnonimo)
            .then(rs => {              
                localStorage.setItem("sugerenciasNoLogin",rs);
                localStorage.setItem("sugerenciasNoLoginCreated",Date.now());
                resp = JSON.parse(rs);
                renderNoLogueado(resp);
                sugerenciasNoLogin(resp);
            });
        }else{
            get(urlNavAnonimoExt)
            .then(rs => {         
                localStorage.setItem("sugerenciasNoLogin",rs);
                localStorage.setItem("sugerenciasNoLoginCreated",Date.now());
                resp = JSON.parse(rs);
                renderNoLogueado(resp);
                sugerenciasNoLogin(resp);
            });
        }        
    }
}


const randomFn = () => {
    return Math.floor((Math.random() * 10) + 1);
}

const renderNoLogueado = (notas) => {
    if (document.querySelector("#bloque-2")) {
        const notasTemasRecomendados = notas.items.filter(nota => nota.tagDestacado);
        const css = "sin-loguear";
        let html = "";

        if (notasTemasRecomendados !== null &&
            notasTemasRecomendados !== undefined &&
            notasTemasRecomendados.length > 0) {
            const valueToSlice = notasTemasRecomendados.length < 3 ? notasTemasRecomendados.length : 3;

            html += `<div class="techo floatFix">
                    <h4>REGISTRATE EN LA NACION Y </h4>
                    <h4><b>MEJORÁ TU EXPERIENCIA</b></h4>
                    <button class="ingresar"> INGRESÁ </button>
                </div>
                <p>Seguí los temas y autores que más te interesan y enterate, al instante, cada vez que haya nuevas notas</p>
                <section class="mas-seguidos">`;

            for (let nota of notasTemasRecomendados.slice(0, valueToSlice)) {
                const id = nota.tagDestacado.id;                    

                html += `<div class="tema floatFix"><p>${nota.tagDestacado.valor}</p>
                     <button class="seguir" data-preferibleId="${id}" data-preferibleTipoId="7">SEGUIR</button></div>`;
            }
            html += `</section>`;
        }

        const asideBloque2 = document.querySelector("#bloque-2");
        asideBloque2.classList.add(css);
        asideBloque2.innerHTML = html;
    }
    seguirDejarSeguir(document.querySelectorAll('button[class="seguir"]'));
}

const loopArticles = (notas, cantidadATomar) => {
    const valueToSlice = notas.length < cantidadATomar ? notas.length : cantidadATomar;
    notas = notas.filter(n => n.datos != undefined);
    
    //Para test de render nota opinion
    //notas = notas.filter(n => n.datos.template.id === 3);

    let html = "";

    for (let nota of notas.slice(0, valueToSlice)) {
        const notaDato = nota.datos;
        const esNotaOpinion = notaDato.template.id === 3;

        const isNotaRecomendada = nota.origen === "Sugerencia" ? "recomendadas" : "";
        let imagenSrc = "";
        let autorUrl = "";

        if (esNotaOpinion) {
            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].imagen !== undefined && notaDato.autores[0].imagen != null && notaDato.autores[0].imagen.id > 0 && notaDato.autores[0].imagen.extension != null && notaDato.autores[0].imagen.extension != "") {
                imagenSrc = `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.autores[0].imagen.id, "", 90, notaDato.autores[0].imagen.extension)}"/>`;
                
            }   
            if (notaDato.autores !== undefined && notaDato.autores !== null && notaDato.autores.length > 0 && notaDato.autores[0].nombre != null && notaDato.autores[0].id != null && notaDato.autores[0].id > 0) {
                const url = Utilities.formatoUrlAcuAutor(notaDato.autores[0].nombre, notaDato.autores[0].id);

                autorUrl = `<a href="${url}" class="autor">${notaDato.autores[0].nombre}</a>`;
            }
        } else {
            imagenSrc = (notaDato.imagen && notaDato.imagen !== undefined && notaDato.imagen != null && notaDato.imagen.id > 0 && notaDato.imagen.extension != null && notaDato.imagen.extension != "")
                ? `<img src="${BucketTools.urlBucketBalance(urlBucket, notaDato.imagen.id, 140, "", notaDato.imagen.extension)}"/>`
                : "";
        }

        const notaUrl = nota.contenido_id + "-" + Utilities.FormatearUrl(nota.titulo),
            tags = notaDato.temas;
        let tag;
        let tagHtml = "";

        if (tags && tags.length > 0) {
            tag = tags[0];
            tagHtml = `<h3 class="tag"><a href="${Utilities.formatoUrlAcuTag(tag.descripcion, tag.id)}">${tag.descripcion}</a></h3>`;
        }

        html += `<article title="" class="nota m ${esNotaOpinion ? " autor" : " foto"} floatFix ${isNotaRecomendada}">
                    <a href="${notaUrl}" class="figure">
                        ${imagenSrc}
                    </a>`;

        if (!esNotaOpinion) {
            html += tagHtml;
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>`;
        } else {
            html += `<h2>
                        <a href="${notaUrl}">${nota.titulo}</a>
                        </h2>
                        ${autorUrl}`;
        }
        html += `</article>`;
    }
    return html;
}

/////////////////////////////////////TE PUEDE INTERESAR - NOTA///////////////////////////////////////////////////////////////////

const ejecutarSugerenciasPreferencias = (contenidosSuge) => {
    sugerencias(contenidosSuge);
}

export const sugerencias = (notas) => {
    if (notas != null && notas.length > 0) { 
        
        notas = notas.filter(item => item.datos != null && item.datos.imagen !== null && item.datos.imagen !== undefined);
        
        
        let notasBloque1 = notas.slice(0, 7);
        let notasBloque2 = notas.slice(7, 15);
        let notasBloque3 = notas.slice(15, 20);
        let contador = 0;
        
        let html = `<aside class="puede-interesar" id="bloque-3">
                    <div class="fila-1 floatFix" id="sugeridasBloque3F1">
                    <h4>Te puede interesar</h4>
                    <div class="columna-doble">${getArticleSugerido(notas[0], 514)}</div>`;
    
        let article = "";
        notasBloque1.shift();
        for (var nota of notasBloque1) {
            article += getArticleSugerido(nota, 216);
            contador++;
            
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
        }
        html += "</div>";
        //todo: ESto deberia contemplar cuando es "Promocion???"
        //<div class="columna">
        //    <a title="" href="" class="nota">
        //        <figure style="background-image:url('/Statics/img/messi.png')">
        //            <div class="transparente">
        //                <h5>Messi
        //                    <b>Estadísticas</b>
        //                </h5>
        //                <label>todas las <b>tablas</b> y <b> comparativos</b><span>&#8594;</span></label>
        //            </div>
        //        </figure>
        //    </a>
        //</div>
        html += `<div class="fila-2 floatFix" id="sugeridasBloque3F2">`;
        article = "";
        contador = 0;
        for (var nota of notasBloque2) {
            article += getArticleSugerido(nota, 216);
            contador++;
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
            if (contador === 5) {
                article = getArticleSugerido(nota, 514);
                html += `<div class="columna-doble">${article}</div>`;
                article = "";
                contador++;
            }
        }
        html += `</div><div class="fila-3 floatFix" id="sugeridasBloque3F3">`;

        
        for (var nota of notasBloque3) {
            html += getArticleSugerido(nota, 216);
        }
        html += `</div></aside>`;
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html; 
    }
}

const sugerenciasNoLogin = (notas) => {
    if (notas != null && notas.items.length > 0) { 
        
        notas = notas.items.filter(item => item != null && item.imagenes !== null && item.imagenes !== undefined && item.imagenes.length > 0);
        
        
        let notasBloque1 = notas.slice(0, 7);
        let notasBloque2 = notas.slice(7, 15);
        let notasBloque3 = notas.slice(15, 20);
        let contador = 0;
        
        let html = `<aside class="puede-interesar" id="bloque-3">
                    <div class="fila-1 floatFix" id="sugeridasBloque3F1">
                    <h4>Te puede interesar</h4>
                    <div class="columna-doble">${getArticleSugeridoSinLogin(notas[0], 514)}</div>`;
    
        let article = "";
        notasBloque1.shift();
        for (var nota of notasBloque1) {
            article += getArticleSugeridoSinLogin(nota, 216);
            contador++;
            
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
        }
        html += "</div>";
        //todo: ESto deberia contemplar cuando es "Promocion???"
        //<div class="columna">
        //    <a title="" href="" class="nota">
        //        <figure style="background-image:url('/Statics/img/messi.png')">
        //            <div class="transparente">
        //                <h5>Messi
        //                    <b>Estadísticas</b>
        //                </h5>
        //                <label>todas las <b>tablas</b> y <b> comparativos</b><span>&#8594;</span></label>
        //            </div>
        //        </figure>
        //    </a>
        //</div>
        html += `<div class="fila-2 floatFix" id="sugeridasBloque3F2">`;
        article = "";
        contador = 0;
        for (var nota of notasBloque2) {
            article += getArticleSugeridoSinLogin(nota, 216);
            contador++;
            if (contador % 2 === 0) {
                html += `<div class="columna">${article}</div>`;
                article = "";
            }
            if (contador === 5) {
                article = getArticleSugeridoSinLogin(nota, 514);
                html += `<div class="columna-doble">${article}</div>`;
                article = "";
                contador++;
            }
        }
        html += `</div><div class="fila-3 floatFix" id="sugeridasBloque3F3">`;

        
        for (var nota of notasBloque3) {
            html += getArticleSugeridoSinLogin(nota, 216);
        }
        html += `</div></aside>`;
        document.querySelector('div[data-module="nota-sugeridas"]').innerHTML = html; 
    }
}

const getArticleSugerido = (nota, width) => {

    let imgHtml = "";
    if (nota.datos.imagen != null && nota.datos.imagen.id > 0 && nota.datos.imagen.extension != null && nota.datos.imagen.extension != "") {
        imgHtml = `<img src="${BucketTools.urlBucketBalance(urlBucket, nota.datos.imagen.id, "", width, nota.datos.imagen.extension)}"/>`;
    }
    
    return `<article title="" class="nota">
              <a class="figure" href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">                                                                
                  ${imgHtml}
              </a>
              <h2><a href="${nota.contenido_id}-${Utilities.FormatearUrl(nota.titulo)}">${nota.titulo}</a></h2>
          </article>`;
}

const getArticleSugeridoSinLogin = (nota, width) => {
    let imgHtml = "";
    if (nota.imagenes instanceof Array && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
        imgHtml = `<img src="${BucketTools.urlBucketBalance(urlBucket, nota.imagenes[0].src, "", width)}"/>`;
    }
    let html = `<article title="" class="nota">
                  <a class="figure" href="${Utilities.FormatearUrl(nota.url)}">                                                                
	                  ${imgHtml}
                  </a>
                  <h2><a href="${Utilities.FormatearUrl(nota.url)}">${nota.titulo}</a></h2>
                </article>`;
    return html;    
}

export const registrarAccesosAcumulados = () => {
    if (SessionLogin.init()) {
        const apiPerso = SessionLogin.initPerso();

        const preferibleAcumulado = document.querySelector('div[data-preferibles]').getAttribute('data-preferibles');
        const ctx = null;
        apiPerso.sugerencias
            .registrarAccesos(preferibleAcumulado, ctx)
            .then(console.log.bind(console, 'registrarAccesos'))
            .catch(console.log.bind(console, 'registrarAccesos'));
        apiPerso.execute()
            .then(console.log.bind(console, 'execute '))
            .catch(console.log.bind(console, 'error'));
    }
}




// WEBPACK FOOTER //
// ./Statics/scripts/common/personalizacion.js